export const GET_SCHEDULED_TASK_DATA_BEGIN = 'GET_SCHEDULED_TASK_DATA_BEGIN'
export const GET_SCHEDULED_TASK_DATA_SUCCESS = 'GET_SCHEDULED_TASK_DATA_SUCCESS'
export const GET_SCHEDULED_TASK_DATA_ERROR = 'GET_SCHEDULED_TASK_DATA_ERROR'

export const TASK_ASSIGNMENT_BEGIN = 'TASK_ASSIGNMENT_BEGIN'
export const TASK_ASSIGNMENT_SUCCESS = 'TASK_ASSIGNMENT_SUCCESS'
export const TASK_ASSIGNMENT_ERROR = 'TASK_ASSIGNMENT_ERROR'